module.exports = __webpack_public_path__ + "img/Травмы локтевого сустава.d221aafa.jpg";